var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',[_c('h2',{on:{"click":function($event){return _vm.increment()}}},[_vm._v(_vm._s(_vm.$t("profile.edit.header")))]),_c('Profile'),_c('Flooding',{ref:"flood"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }